import { gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';
import { getBBox } from '../gsap-utils';

const createMagicBlock = (target: Element): SVGRectElement | undefined => {
  const newTarget = (target?.querySelector ? target?.querySelector?.('.text') : target) ?? target;

  let color: string | null;
  const text = newTarget.querySelector('.text');
  const tspan = newTarget.querySelector('tspan[fill]');

  if (text) {
    color = text.getAttribute('fill');
  } else if (tspan) {
    color = tspan.getAttribute('fill');
  } else {
    color = newTarget.getAttribute('fill');
  }

  const box = getBBox(newTarget) ?? newTarget.getBoundingClientRect();

  if (box) {
    const magicBlock = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

    magicBlock.setAttribute('x', box.x.toString());
    magicBlock.setAttribute('y', box.y.toString());
    magicBlock.setAttribute('width', box.width.toString());
    magicBlock.setAttribute('height', box.height.toString());
    magicBlock.setAttribute('fill', color ?? 'black');
    magicBlock.setAttribute('opacity', '1');
    magicBlock.setAttribute('fill-opacity', '1');

    return magicBlock;
  }

  return undefined;
};

export const magicBlock: gsapTimelineFunc = (target) => {
  const magicBlock = createMagicBlock(target as Element);
  const parent = (target as SVGElement).parentElement;

  if (parent && magicBlock) {
    parent.appendChild(magicBlock);

    const magicBlockTimeline = gsap
      .timeline()
      .fromTo(
        magicBlock,
        {
          duration: 0,
          transformOrigin: 'left center',
          transformBox: 'fill-box',
          transform: 'scaleX(0)',
        },
        {
          duration: 0.45,
          transformOrigin: 'left center',
          transform: 'scaleX(1)',
        }
      )
      .to(magicBlock, {
        duration: 0.55,
        opacity: 0,
        transformOrigin: 'right center',
        transform: 'scaleX(0)',
      });

    const textTimeline = gsap
      .timeline()
      .from(target, { opacity: 0, delay: 0.25, duration: 0.5 })
      .to(target, { opacity: 1, delay: 0.95, duration: 0.05 });

    return gsap.timeline().add(magicBlockTimeline).add(textTimeline, '<');
  }

  return gsap.timeline();
};
